<template>
  <Head title="Two-Factor Authentication" />

  <div class="container-fluid d-flex flex-column h-100 onboarding-container">
    <div class="row m-4 justify-content-center onboarding-new align-items-stretch">
      <div class="col-lg-9 col-12">
        <div class="row h-100 justify-content-center align-items-center flex-grow-1">
          <div class="container-fluid col-12">
            <Link class="navbar-brand" href="/">
              <img src="/img/logo_png/avid_logo_black.png" alt="Avid" class="navbar-brand-logo-avidonly px-2">
            </Link>
          </div>
          <div class="registration-form-container col-lg-5 col-12 mt-5 mt-lg-0 d-flex flex-column justify-content-center align-items-stretch">
            <Link class="navbar-brand d-flex justify-content-center w-100" href="/">
              <img src="/img/logo_png/logo_tile.png" alt="Avid" class="mb-3" style="width: 50px; height: 50px;">
            </Link>

            <h2 class="text-center mb-4">Two-Factor Authentication</h2>
            <p class="text-center text-muted mb-4">Please enter the code from your authenticator app or a recovery code.</p>

            <form method="POST" action="/two-factor-challenge" class="w-100">
              <input type="hidden" name="_token" :value="csrfToken">

              <div v-if="!useRecoveryCode" class="mb-3">
                <input
                  id="code"
                  type="text"
                  inputmode="numeric"
                  autocomplete="one-time-code"
                  placeholder="Authentication code"
                  class="form-control form-control-lg"
                  :class="{ 'is-invalid': hasError('code') }"
                  name="code"
                  v-model="form.code"
                  maxlength="6"
                  pattern="[0-9]*"
                 aria-label="Text input">
                <span v-if="hasError('code')" class="invalid-feedback d-block" role="alert">
                  {{ errorMessage('code') }}
                </span>
              </div>

              <div v-else class="mb-3">
                <input
                  id="recovery_code"
                  type="text"
                  placeholder="Recovery code"
                  class="form-control form-control-lg"
                  :class="{ 'is-invalid': hasError('recovery_code') }"
                  name="recovery_code"
                  v-model="form.recovery_code"
                 aria-label="Recovery code">
                <span v-if="hasError('recovery_code')" class="invalid-feedback d-block" role="alert">
                  {{ errorMessage('recovery_code') }}
                </span>
              </div>

              <div class="mt-4">
                <button type="submit" class="btn btn-primary w-100">
                  Verify
                </button>
              </div>
            </form>

            <div class="text-center mt-3">
              <button type="button" class="btn btn-link px-1" @click.prevent="useRecoveryCode = !useRecoveryCode">
                {{ useRecoveryCode ? 'Use authenticator code' : 'Use a recovery code' }}
              </button>
              <span class="text-muted small">or</span>
              <Link href="/login" class="btn btn-link px-1">go back to login</Link>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 d-none d-lg-block bg-with-image"></div>
    </div>
  </div>
</template>

<script setup>
import { Head, Link } from '@inertiajs/vue3';
import { computed, reactive, ref } from 'vue';

const props = defineProps({
  errors: {
    type: Object,
    default: () => ({})
  }
});

/** Normalize errors to a string per field (Inertia may pass string or array). */
const errorMessage = (field) => {
  const err = props.errors?.[field];
  if (!err) return '';
  return Array.isArray(err) ? err[0] : err;
};

const hasError = (field) => !!props.errors?.[field];

const csrfToken = computed(() => document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'));

// Show recovery code field when there's an error on it (e.g. invalid/used code)
const useRecoveryCode = ref(!!props.errors?.recovery_code);
const form = reactive({
  code: '',
  recovery_code: ''
});
</script>
